angular.module('elfium').directive('businessCaseList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'businessCaseListController',
        templateUrl: elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseList')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseList.ts